var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSettingsFaq(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 17.0375L5.27333 18.7692C5.03556 19.0076 4.76389 19.0613 4.45833 18.9303C4.15278 18.7993 4 18.5654 4 18.2285V5.50433C4 5.09064 4.14688 4.7365 4.44063 4.4419C4.73438 4.1473 5.0875 4 5.5 4H18.5C18.9125 4 19.2656 4.1473 19.5594 4.4419C19.8531 4.7365 20 5.09064 20 5.50433V15.5332C20 15.9469 19.8531 16.301 19.5594 16.5956C19.2656 16.8902 18.9125 17.0375 18.5 17.0375H7ZM6.375 15.5332H18.5V5.50433H5.5V16.4107L6.375 15.5332Z",
    fill: "#909090"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsFaq);
export default __webpack_public_path__ + "static/media/settings_faq.94327862c54e037a9ada04cd7f8bafaa.svg";
export { ForwardRef as ReactComponent };